import React, { useContext, useEffect } from 'react';

import { AuthContext } from '../../external-components';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const Authenticate = () => {
    const location = useLocation();
    const history = useHistory();
    const { authenticateUser } = useContext(AuthContext);

    useEffect(() => {
        (async () => {
            const userParams = location.search ? location.search.substring(1) : null;
            const isAuthenticated = await authenticateUser(userParams);

            if (isAuthenticated) {
                const isUserTimeStampPresent = sessionStorage.getItem('userLoginTimeStamp');
                if (!isUserTimeStampPresent) {
                    const date = new Date();
                    sessionStorage.setItem('userLoginTimeStamp', date.toString());
                }
                const routeName = localStorage.getItem('redirectTo');

                if (routeName) {
                    // GaaS was enforcing this to always redirect to eligibility page.
                    // Changing this as TollRelief flow is different
                    history.replace(routeName);
                }
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <div>Authenticating...</div>;
};

export default Authenticate;
